export default __webpack_public_path__ + "static/mock-reward-2-d0bf3c47c0e83499de4f29c86982b07c.webp";